export default __webpack_public_path__ + "static/media/chat.c6f6e59d.svg";